import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class Programmes {
	constructor(elm) {
        this.elm = elm;
        this.aside = this.elm.querySelector('[data-aside]');
        this.listContainer = this.elm.querySelector('[data-programmes-list]');

        this.cards = this.elm.querySelectorAll('[data-programme-card]');

        this.cards.forEach(card => {
            card.addEventListener('click', (e) => {
                e.preventDefault();
            });
        });

        const mm = gsap.matchMedia();

		mm.add('(min-width: 1200px)', () => {
            this.trigger = ScrollTrigger.create({
                trigger: this.elm,
                start: "top 32",
                end: () => `+=${this.listContainer.offsetHeight - this.aside.offsetHeight + 32}`,
                pin: this.aside,
                pinSpacing: true
            });
		});
    }

    destroy() {
       this.trigger.kill();
    }
}